// **********************************************************
// Product Gallery Modal
// **********************************************************

const productGalleryModalMain = document.querySelectorAll('[data-slider="product-gallery-modal-main-slider"]');
const productGalleryModalThumb = document.querySelectorAll('[data-slider="product-gallery-modal-thumb-slider"]');

// *******************************************************************************
// 1.1 - Product Gallery Thumb Slider
// *******************************************************************************

const productGalleryModalThumbSliderOptions = {
  direction: 'vertical',
  slidesPerView: 5,
  spaceBetween: 1,
  watchOverflow: true,
  speed: 600,
  mousewheel: true,
};

productGalleryModalThumb.forEach((ele) => new Swiper(ele, productGalleryModalThumbSliderOptions));

// *******************************************************************************
// 1.2 -Product Gallery Main Slider
// *******************************************************************************

const productGalleryModalMainOptions = {
  direction: 'vertical',
  slidesPerView: 'auto',
  mousewheel: true,
  spaceBetween: 74,
  grabCursor: true,
  loop: true,
  speed: 800,
  simulateTouch: true,
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    1023: {
      slidesPerView: 'auto',
      spaceBetween: 28,
    },
  },
};

productGalleryModalMain.forEach((el, i) => {
  const productGalleryModalMainParent = el.closest('.product-gallery-modal');
  const arrowDown = productGalleryModalMainParent.querySelector('.arrow-down');
  const arrowUp = productGalleryModalMainParent.querySelector('.arrow-up');

  productGalleryModalMainOptions.navigation.nextEl = arrowDown;
  productGalleryModalMainOptions.navigation.prevEl = arrowUp;

  productGalleryModalMainOptions.thumbs.swiper = productGalleryModalThumb[i].swiper;

  const productGalleryModalSlider = new Swiper(el, productGalleryModalMainOptions);

  attachEvent('[data-modal-slide]', 'click', (ev) => {
    const targetSlideEle = ev.target.closest('.product-showcase__image--main');
    const targetSlideAttr = targetSlideEle.getAttribute('data-modal-slide');
    const parentEle = targetSlideEle.closest('[product-gallery-parent]');
    const galleryModal = parentEle.querySelector('.product-gallery-modal');
    if (galleryModal) {
      galleryModal.classList.add('is-open-modal');
      toggleBodyScrollLock(true);
    }
    productGalleryModalSlider.slideTo(targetSlideAttr - 1, 0);
  });
});

// **********************************************************
// 1.3 Product Gallery Modal When Escape Key Press
// **********************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modalElem = document.querySelectorAll('.product-gallery-modal');
    if (modalElem.length > 0) {
      modalElem.forEach((el) => {
        el.classList.remove('is-open-modal');
        toggleBodyScrollLock(false);
      });
    }
  }
});

// **********************************************************
// 1.4 Product Gallery Modal When Click On Close
// **********************************************************

attachEvent('.product-gallery-modal__close', 'click', (ev) => {
  const parentEle = ev.target.closest('.product-gallery-modal');
  const productPopupEle = ev.target.closest('[modal-product-popup]');
  parentEle.classList.remove('is-open-modal');
  ev.preventDefault();
  if (!productPopupEle) {
    toggleBodyScrollLock(false);
  }
});
